import React from "react";
import { Box, Typography, Button } from "../../ui-kit";
import { ONBOARDING_TEXT } from "../text.constants";
import { useStyles } from "./RejectedFieldRow.styles";

export interface RejectedFieldRowProps {
  label: string;
  value: string;
  onUndo?: () => void;
  className?: string;
}

/** Inline rejected-state treatment for a single text field, mirroring RejectedCard's look for images. */
const RejectedFieldRow = ({ label, value, onUndo, className }: RejectedFieldRowProps) => {
  const classes = useStyles();
  return (
    <Box className={`${classes.root}${className ? ` ${className}` : ""}`}>
      <Box className={classes.headerRow}>
        <Typography className={classes.label}>{label}</Typography>
        {onUndo && (
          <Button size="small" className={classes.undoBtn} onClick={onUndo} disableRipple>
            {ONBOARDING_TEXT.DVP_UNDO_BTN}
          </Button>
        )}
      </Box>
      <Typography className={classes.value}>{value}</Typography>
    </Box>
  );
};

export default RejectedFieldRow;
